<div
  class="add-dialog-three-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- ! Label -->
  <ddc-text-gradient class="text-2xl" [_icon]="_titleIcon" [_text]="_title" [_type]="'1'"></ddc-text-gradient>
  <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
  <!-- ! Add Form -->
  <form class="add-dialog-two-form" [formGroup]="_form">
    <!-- ! Form Error -->
    @if (_addError) {
      <div class="alert alert-danger">
        <div>{{ _addError }}</div>
        @if (_isSubscriptionError) {
          <ddc-button-u-one
            [_dynamicRoute]="'/pricing'"
            [_hasBorder]="true"
            [_icon]="'auto_awesome'"
            [_label]="'Upgrade'"
            (click)="closeDialog()"
          ></ddc-button-u-one>
        }
      </div>
    }
    @if (_addedField) {
      <div>
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="30px" [options]="options"></ng-lottie>
          </div>
          <div>&nbsp;&nbsp;&nbsp;"{{ _addedField }}" has been added.</div>
        </div>
      </div>
    }
    <!-- ! Field -->
    @if (!_addedField && !_isSubscriptionError) {
      <div class="add-dialog-data">
        <div class="add-dialog-title">
          <mat-form-field>
            <mat-label>{{ _firstFieldTitle }}</mat-label>
            <input formControlName="_title" matInput />
            <!-- * Errors -->
            @if (title.hasError('maxlength')) {
              <mat-error>
                Maximum <strong>{{ _titleMaxLength }}</strong> characters.
              </mat-error>
            }
            @if (title.hasError('required')) {
              <mat-error> Required. </mat-error>
            }
          </mat-form-field>
        </div>
        @if (_isDic) {
          <div>
            <mat-form-field class="add-dialog-description">
              <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Description</mat-label>
              <textarea
                formControlName="_description"
                matInput
                placeholder="Ex. The round fruit of a tree of the rose family"
              ></textarea>
              <!-- * Errors -->
              @if (description.hasError('maxlength')) {
                <mat-error>
                  Maximum <strong>{{ _descriptionMaxLength }}</strong> characters.
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px"></mat-divider>
    <div class="add-dialog-two-submit-container">
      <div class="add-dialog-two-submit-container-right">
        <!-- Cancel -->
        <button class="add-dialog-two-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
        <!-- Add -->
        @if (!_addedField && !_isSubscriptionError) {
          <ddc-button-s-one
            class="ddc-submit-btn"
            [_isLoading]="_isCreateBtnLoading"
            [_label]="_submitBtnText"
            (buttonClick)="add()"
          ></ddc-button-s-one>
        }
        <!-- Go To Element -->
        @if (_addedField && _isDic && !_isSubscriptionError) {
          <ddc-button-s-two
            [_icon]="'arrow_forward'"
            [_label]="'To the Dictionary'"
            (click)="openDic(_addedElementId)"
          ></ddc-button-s-two>
        }
      </div>
    </div>
  </form>
</div>
